import { render, staticRenderFns } from "./resourceDetails.vue?vue&type=template&id=36e1fd0c&"
import script from "./resourceDetails.vue?vue&type=script&lang=js&"
export * from "./resourceDetails.vue?vue&type=script&lang=js&"
import style0 from "./resourceDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports